import React from "react";

import { Row } from "react-bootstrap";
import { AlvaraDeObra } from "../../../../shared/interfaces/IProperties";
// import { Divisor } from "../../bci/styles";
import { DivisorPeB } from "../divisor";

interface ZoneamentoProps {
    alvaras?: AlvaraDeObra[];
}

export const AraucariaAlvaraObra: React.FC<ZoneamentoProps> = ({ alvaras }) => {
    return (
        <>
            <DivisorPeB />
            <Row>
                {alvaras && alvaras.length > 0 ? (
                    <>
                        <p className="text-center font-bold">
                            Alvarás de Construção
                        </p>
                        <div>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Número</th>
                                        <th>Tipo</th>
                                        <th>Processo Administrativo</th>
                                        <th>Ano</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {alvaras.map((alvara) => (
                                        <tr key={alvara.id}>
                                            <td>{alvara.numero}</td>
                                            <td>{alvara.tipo}</td>
                                            <td>
                                                {alvara.processoadministrativo}
                                            </td>
                                            <td>{alvara.ano}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="text-center">
                            Não foram encontrados Alvarás de Construção para o
                            imóvel. Em caso de dúvidas, entrar em contato com a
                            Secretaria Municipal de Urbanismo
                        </p>
                    </div>
                )}
            </Row>
            <DivisorPeB />
        </>
    );
};
